module.exports = __webpack_public_path__ + "img/fconnect2.4f362a68.png";